import { Link } from "react-router-dom";
import { pricingPlans } from "@/mocks/landing";

export default function Pricing() {
  return (
    <section id="pricing" className="bg-background-100 px-4 md:px-10 py-20 md:py-32">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-foreground-600 mb-4">
            <span className="w-6 h-px bg-foreground-400"></span>
            Honest pricing
          </p>
          <h2 className="font-heading text-4xl md:text-6xl font-light text-foreground-950 leading-[1.05]">
            Flat-fee visits. No subscriptions, no surprises.
          </h2>
        </div>
        <p className="text-foreground-700 text-sm max-w-xs leading-relaxed">
          Save 15% on every visit when you set a recurring rhythm. Cancel or pause in two taps.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {pricingPlans.map((plan) => (
          <article
            key={plan.name}
            className={`rounded-3xl p-3 flex flex-col h-full ${
              plan.featured
                ? "bg-primary-900 text-background-50"
                : "bg-background-50 border border-background-200"
            }`}
          >
            <div className="rounded-2xl h-56 md:h-64 overflow-hidden mb-6">
              <img src={plan.image} alt={plan.name} className="w-full h-full object-cover object-top" />
            </div>

            <div className="px-4 pb-5 flex-1 flex flex-col">
              <div className="flex items-baseline justify-between mb-5">
                <h3
                  className={`font-heading text-2xl font-medium ${
                    plan.featured ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {plan.name}
                </h3>
                <div className="text-right">
                  <p
                    className={`font-heading text-3xl font-medium ${
                      plan.featured ? "text-background-50" : "text-foreground-950"
                    }`}
                  >
                    {plan.price}
                  </p>
                  <p
                    className={`text-xs ${
                      plan.featured ? "text-background-200/80" : "text-foreground-600"
                    }`}
                  >
                    {plan.cadence}
                  </p>
                </div>
              </div>

              <ul className="space-y-3 mb-7 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <span
                      className={`mt-0.5 w-5 h-5 flex items-center justify-center rounded-full ${
                        plan.featured ? "bg-background-50/15 text-accent-300" : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className={plan.featured ? "text-background-100" : "text-foreground-800"}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <Link
                to="/booking"
                className={`group flex items-center justify-between rounded-full pl-5 pr-2 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  plan.featured
                    ? "bg-background-50 text-foreground-950 hover:bg-background-100"
                    : "bg-foreground-950 text-background-50 hover:bg-foreground-900"
                }`}
              >
                {plan.cta}
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full ${
                    plan.featured ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-950"
                  }`}
                >
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>

              <p
                className={`text-xs mt-4 ${
                  plan.featured ? "text-background-200/70" : "text-foreground-600"
                }`}
              >
                Free reschedule up to 12 hours before your visit.
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}